import { IContent, IResponse, IResponseList, ISection } from 'src/interface';
import * as HttpUtils from 'src/utils/http';

export interface IReportParams {
    object_id: number;
    feedback:
    | { type: string }
    | { type: string; tags: string[] }
    | { type: string; message: string };
    object_type: number;
}

export const ContentService = {
    getList(path: string, params: {}): Promise<IResponseList<IContent>> {
        return HttpUtils.getWithPath(path, params);
    },
    getListByregion(shortName: number): Promise<IResponse<any>> {
        return HttpUtils.getWithPath('/content/get/list-by-region', {
            shortName,
        });
    },
    getListRelated(id: number): Promise<IResponse<ISection<any>[]>> {
        return HttpUtils.getWithPath('/content/get/list-related', {
            id,
        });
    },
    getListCustom(params: {}): Promise<any> {
        return HttpUtils.getWithPath('/content/get/list-by-custom', params);
    },
    getListRelatedByUser(params: {}): Promise<any> {
        return HttpUtils.getWithPath('/user/get/contents-related', params);
    },
    getListHistory(params: {}): Promise<any> {
        return HttpUtils.getWithPath('/user/get/contents-history', params);
    },
    getDetail(id: number): Promise<IResponse<any>> {
        return HttpUtils.getWithPath('/content/get/detail', { id });
    },
    getAdsMasthead(id: number): Promise<IResponse<any>> {
        return HttpUtils.getWithPath('/ad/get/masthead', { contentId: id });
    },
    report(body: IReportParams): Promise<IResponse<any>> {
        return HttpUtils.postWithUrl('/reports/post/report', {}, body);
    },
};

export default ContentService;
